'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.asyncProps = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.mapStateToProps = mapStateToProps;
exports.App = App;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = require('react-router-redux');

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _trvFedApiClient = require('../trv-fed-api-client.js');

var _trvFedApiClient2 = _interopRequireDefault(_trvFedApiClient);

var _Tracking = require('../containers/Tracking');

var _Tracking2 = _interopRequireDefault(_Tracking);

var _BannerContainer = require('../containers/BannerContainer');

var _BannerContainer2 = _interopRequireDefault(_BannerContainer);

var _Header = require('../components/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Footer = require('../components/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _GlobalError = require('../components/GlobalError');

var _GlobalError2 = _interopRequireDefault(_GlobalError);

var _seo = require('../modules/seo');

var _currencies = require('../modules/currencies');

var _search = require('../modules/search');

var _auth = require('../modules/auth');

var _query = require('../helpers/query');

var _url = require('../helpers/url.js');

var _exception = require('../modules/exception');

require('../css/common.min.css');

require('../css/additional.css');

require('../css/additional-for-home.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/makeomatic/redux-connect/blob/master/docs/API.MD
var asyncProps = exports.asyncProps = [{
  promise: function preload(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        location = _ref.location,
        params = _ref.params;

    var state = getState();
    var promises = [];
    var urls = state.urls,
        i18n = state.i18n,
        currencies = state.currencies,
        httpRequest = state.httpRequest,
        seo = state.seo,
        auth = state.auth;

    // Need to clear exceoption first when a user press the back button

    dispatch((0, _exception.clearException)());

    if (seo.pathname !== location.pathname) {
      var seoQuery = {};
      switch (true) {
        case !!params.hotelID:
          seoQuery.type = 'hotel';
          break;
        case !!params.spotID:
          seoQuery.type = 'spot';
          break;
        case !!params.cityID:
          seoQuery.type = 'city';
          break;
        case !!params.subdivisionID:
          seoQuery.type = 'subdivision';
          break;
        case !!params.countryID:
          seoQuery.type = 'country';
          break;
        default:
          seoQuery.type = 'top';
          break;
      }
      seoQuery.id = (0, _query.getIds)(params);
      promises.push((0, _trvFedApiClient2.default)(urls.api.seo, 'GET', seoQuery, httpRequest.req, undefined, 2000).then(function (res) {
        return dispatch((0, _seo.set)((0, _extends3.default)({}, res, { pathname: location.pathname })));
      }, function (res) {
        // Should not throw exception
        // Even if error has been occurred, service should be available
        console.error(res);
      }));
    }

    // XXX: Data checking logic should be moved to the currencies reducer
    if (currencies.length < 2) {
      promises.push((0, _trvFedApiClient2.default)(urls.api.currencies, 'GET', {}, httpRequest.req, {
        maintenance: { title: i18n.errors.serviceUnavailable, message: i18n.errors.pleaseTryAgainLater },
        timeout: { title: i18n.errors.serviceUnavailable, message: i18n.errors.pleaseTryAgainLater }
      }, 3000).then(function (res) {
        return dispatch((0, _currencies.set)(res));
      }, function (res) {
        // Fallback to property's currency
        dispatch((0, _search.update)({ currency: 'JPY' }));
        // Should not throw exception
        // Even if error has been occurred, service should be available
        console.error(res);
      }));
    }

    // TODO: only for travel.rakuten.com.tw now
    // XXX: the API requires JSONP
    // get the auth token from cookie
    if (i18n.lang === 'zh_TW' && !auth.loaded) {
      var serverCookies = httpRequest.req && httpRequest.req.cookies ? httpRequest.req.cookies : {};
      var token = serverCookies.gridt;
      if (token) {
        dispatch((0, _auth.load)());
        promises.push(_promise2.default.all([(0, _trvFedApiClient2.default)(urls.api.member, 'GET', { callback: '', para: token }, httpRequest.req, undefined, undefined, true), (0, _trvFedApiClient2.default)(urls.api.point, 'GET', { callback: '', para: token }, httpRequest.req, undefined, undefined, true)]).then(function (_ref2) {
          var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
              username = _ref3[0].username,
              totalPoint = _ref3[1].totalPoint;

          dispatch((0, _auth.loadSuccess)({ username: username, totalPoint: totalPoint }));
        }, function (err) {
          console.error(err);
          dispatch((0, _auth.loadFail)(err));
        }));
      }
    }

    // XXX: only support campaign banner for travel.rakuten.com.tw so far
    if (i18n.lang === 'zh_TW') {
      promises.push(_BannerContainer2.default.fetchGlobalBanner({ dispatch: dispatch, state: state, params: params }));
    }

    return _promise2.default.all(promises);
  }
}];

function mapStateToProps(state, ownProps) {
  return {
    i18n: state.i18n,
    urls: state.urls,
    search: state.search,
    seo: state.seo,
    currency: state.currencies.find(function (item) {
      return item.id === state.search.currency;
    }) || (0, _assign2.default)({}, state.currencies[0]),
    currencies: state.currencies.filter(function (item, index) {
      return index > 0;
    }),
    domains: state.domains,
    errors: state.exception.errors,
    location: ownProps.location,
    params: ownProps.params,
    router: ownProps.router,
    req: state.httpRequest.req
  };
}

var mapDispatchToProps = exports.mapDispatchToProps = {
  updateSearch: _search.update,
  push: _reactRouterRedux.push
};

function App(props) {
  var updateSearch = props.updateSearch,
      seo = props.seo,
      location = props.location,
      router = props.router,
      req = props.req;


  var headerProps = {
    currency: props.currency,
    currencies: props.currencies,
    domains: props.domains,
    i18n: props.i18n,
    urls: props.urls,
    onCurrencyChange: function onCurrencyChange(currency) {
      updateSearch({ currency: currency });
      _reactCookie2.default.save('currency', currency, { path: '/',
        domain: '.travel.rakuten.' + (0, _url.extractDomain)(window.location.host).ccSLD });
      var newLocation = _lodash2.default.cloneDeep(location);
      delete newLocation.query.price;
      // XXX: delete the currency query from the affiliate site
      delete newLocation.query.currency;
      window.location = '' + window.location.origin + router.createPath(newLocation);
    },
    isMobile: req.useragent.isMobile
  };

  var footerProps = {
    i18n: props.i18n,
    urls: props.urls
  };

  var trackingProps = {
    location: props.location,
    params: props.params
  };

  return _react2.default.createElement(
    'div',
    { id: 'page' },
    _react2.default.createElement(_reactHelmet2.default, seo),
    _react2.default.createElement(_BannerContainer2.default, null),
    _react2.default.createElement(_Header2.default, headerProps),
    props.errors && props.errors.length ? _react2.default.createElement(_GlobalError2.default, {
      title: props.errors[0].title,
      message: props.errors[0].message,
      displaySearchForm: props.errors[0].displaySearchForm
    }) : props.children,
    _react2.default.createElement(_Footer2.default, footerProps),
    _react2.default.createElement(_Tracking2.default, trackingProps)
  );
}

App.propTypes = {
  children: _react.PropTypes.object.isRequired,
  currency: _react.PropTypes.object.isRequired,
  currencies: _react.PropTypes.array.isRequired,
  domains: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.array.isRequired,
  i18n: _react.PropTypes.object.isRequired,
  urls: _react.PropTypes.object.isRequired,
  seo: _react.PropTypes.object.isRequired,
  updateSearch: _react.PropTypes.func.isRequired,
  router: _react.PropTypes.object.isRequired,
  location: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object.isRequired,
  req: _react.PropTypes.object.isRequired
};

var asyncConnectedApp = (0, _reduxConnect.asyncConnect)(asyncProps)(App);

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(asyncConnectedApp);


//////////////////
// WEBPACK FOOTER
// ./src/containers/App.js
// module id = 1232
// module chunks = 0